// extracted by mini-css-extract-plugin
module.exports = {"feedContainer":"FeedStatus_feedContainer__3CVNn","redIcon":"FeedStatus_redIcon__gzq6W","greenIcon":"FeedStatus_greenIcon__1yY0R"};